import { motion } from "framer-motion";
import { ScrollText, Shield, Shirt, Trophy } from "lucide-react";

const GIFTS = [
  { icon: ScrollText, label: "SIJIL KURSUS" },
  { icon: Shield, label: "PIN RASMI" },
  { icon: Shirt, label: "2 HELAI BAJU" },
  { icon: Trophy, label: "SIJIL PELATIH TERBAIK", sub: "untuk peserta terpilih" },
];

export function WhatYouGet() {
  return (
    <section data-testid="kursus-what-you-get" className="relative bg-kursus-bg py-20 sm:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-kursus-gold/5 via-transparent to-transparent" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-4xl text-kursus-white text-center mb-12"
        >
          APA YANG ANDA AKAN <span className="text-kursus-gold">DAPAT?</span>
        </motion.h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {GIFTS.map((g, i) => (
            <motion.div
              key={g.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`kursus-gift-${i}`}
              className="bg-kursus-card border border-kursus-border rounded-lg p-6 text-center hover:-translate-y-1.5 hover:border-kursus-gold/70 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-kursus-gold/10 border border-kursus-gold/40 flex items-center justify-center mx-auto mb-4">
                <g.icon className="w-5 h-5 text-kursus-gold" />
              </div>
              <p className="font-oswald text-sm sm:text-base font-semibold text-kursus-white tracking-wide">{g.label}</p>
              {g.sub && <p className="text-xs text-kursus-muted mt-1">{g.sub}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
